<ng-container *ngIf="env.USE_TAILWIND">
    <div class="signup-complete-form-wrapper">
        <p class="mb-4 text-base">
            {{ 'SIGNUP_COMPLETE_DESCRIPTION' | translate }}
        </p>
        <p class="required-text">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>
        <ng-container
            [ngTemplateOutlet]="
                env.REGISTRATION?.DISABLE_FOCUS_ON_FORM_INVALID ? formWrapperWithoutFocus : formWrapperWithFocus
            "></ng-container>
    </div>
</ng-container>

<ng-template #PERSONAL_CODE>
    <mat-form-field class="full-width signup-complete-field" appearance="outline">
        <mat-label aria-label="{{ 'PERSONAL_CODE' | translate }}" title="{{ 'PERSONAL_CODE' | translate }}">{{
            'PERSONAL_CODE' | translate
        }}</mat-label>
        <input
            [formControl]="signupCompleteForm.controls.personalCode"
            [required]="!this.env.REGISTRATION?.OIDC_SIGNUP_COMPLETE_FIELD_ORDER?.PERSONAL_CODE?.OPTIONAL"
            matInput
            ridangoInput
            aria-label="{{ 'PERSONAL_CODE' | translate }}"
            title="{{ 'PERSONAL_CODE' | translate }}"
            name="personalCode"
            type="number"
            ridangoUntouchOnFocusout />
        <mat-error *ngIf="signupCompleteForm.controls.personalCode.hasError('required')">
            {{
                env.REGISTRATION?.OIDC_SIGNUP_COMPLETE_FIELD_ORDER?.PERSONAL_CODE?.VALIDATION?.TRANSLATION_LABELS
                    .BLANK ?? 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate
            }}
        </mat-error>
    </mat-form-field>
</ng-template>

<ng-template #formWrapperWithFocus>
    <form
        class="signup-complete-form signup-complete-form--mobile-layout"
        [formGroup]="signupCompleteForm"
        (ngSubmit)="completeSignup()"
        ridangoFocusInvalidInput
        autocomplete="on">
        <ng-container [ngTemplateOutlet]="formContentOrdered"></ng-container>
    </form>
</ng-template>

<ng-template #formWrapperWithoutFocus>
    <form
        class="signup-complete-form signup-complete-form--mobile-layout"
        [formGroup]="signupCompleteForm"
        (ngSubmit)="completeSignup()"
        autocomplete="on">
        <ng-container [ngTemplateOutlet]="formContentOrdered"></ng-container>
    </form>
</ng-template>

<ng-template #formContentOrdered>
    <ng-container *ngFor="let fieldKey of fieldOrderKeys" [ngTemplateOutlet]="templateMap[fieldKey]"></ng-container>

    <div
        class="signup-complete-submit-wrapper border-t border-solid border-grey-white_smoke pt-5 dark:border-contrast-yellow">
        <ng-container *ngIf="env.REGISTRATION?.USE_ION_BUTTON; else regularSubmitButton">
            <ion-button
                class="signup-complete-submit register-web-button mb-0 w-full lg:mr-16 lg:w-64"
                [ngClass]="{ 'disabled-button': isSubmitButtonDisabled() || (loading$ | async) }"
                [disabled]="isSubmitButtonDisabled() || (loading$ | async)"
                [attr.aria-label]="'SIGNUP_COMPLETE_BUTTON' | translate"
                type="submit"
                size="large"
                color="secondary">
                <ion-label class="text-base font-semibold normal-case">
                    {{ 'SIGNUP_COMPLETE_BUTTON' | translate }}
                </ion-label>
            </ion-button>
        </ng-container>
        <ng-template #regularSubmitButton>
            <button
                class="signup-complete-submit orb-app-light-dark:h-9 gl-light:bg-secondary vl-app-light:bg-[var(--btn-primary-color)] sr-app-light:bg-[var(--color-secondary)] var-app-light:bg-[var(--color-secondary)] varmland-light:bg-[var(--color-secondary)] mb-0 w-full rounded-lg bg-[var(--color-primary)] py-[1.125rem] shadow-[0px_2px_4px_0px_#0000001A] dark:bg-contrast-yellow dark:text-contrast-black"
                [ngClass]="{ 'disabled-button': isSubmitButtonDisabled() || (loading$ | async) }"
                [attr.aria-label]="'SIGNUP_COMPLETE_BUTTON' | translate"
                [disabled]="isSubmitButtonDisabled() || (loading$ | async)"
                type="submit">
                <ion-label
                    class="gl-light:text-[var(--color-primary)] tallinn-light:text-white jk-light:text-white sr-app-light:text-white pn-app-light:text-white pn-light:text-white pn-app-light:text-white text-base font-semibold normal-case text-contrast-black dark:text-contrast-black">
                    {{ 'SIGNUP_COMPLETE_BUTTON' | translate }}
                </ion-label>
            </button>
        </ng-template>
    </div>
</ng-template>

<ng-template #PHONE_NUMBER>
    <mat-form-field class="full-width signup-complete-field" appearance="outline">
        <mat-label aria-label="{{ 'PHONE_NUMBER' | translate }}" title="{{ 'PHONE_NUMBER' | translate }}">
            {{ 'PHONE_NUMBER' | translate }}
        </mat-label>
        <input
            [formControl]="signupCompleteForm.controls.phoneNumber"
            [required]="!this.env.REGISTRATION?.OIDC_SIGNUP_COMPLETE_FIELD_ORDER?.PHONE_NUMBER?.OPTIONAL"
            matInput
            ridangoInput
            aria-label="{{ 'PHONE_NUMBER' | translate }}"
            title="{{ 'PHONE_NUMBER' | translate }}"
            name="phoneNumber"
            type="tel"
            inputmode="tel"
            ridangoUntouchOnFocusout />
        <mat-error *ngIf="signupCompleteForm.controls.phoneNumber.hasError('required')">
            {{
                env.REGISTRATION?.OIDC_SIGNUP_COMPLETE_FIELD_ORDER?.PHONE_NUMBER?.VALIDATION?.TRANSLATION_LABELS
                    .BLANK ?? 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate
            }}
        </mat-error>
        <mat-error *ngIf="signupCompleteForm.controls.phoneNumber.hasError('phoneTooShort')">
            {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_SHORT' | translate }}
        </mat-error>
        <mat-error *ngIf="signupCompleteForm.controls.phoneNumber.hasError('phoneTooLong')">
            {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_LONG' | translate }}
        </mat-error>
        <mat-error *ngIf="signupCompleteForm.controls.phoneNumber.hasError('invalidPhoneCountryCode')">
            {{ 'LOCAL_INPUT_VALIDATION_PHONE_INVALID_COUNTRY_CODE' | translate }}
        </mat-error>
        <mat-error *ngIf="signupCompleteForm.controls.phoneNumber.hasError('invalidPhoneNumber')">
            {{
                env.REGISTRATION?.OIDC_SIGNUP_COMPLETE_FIELD_ORDER?.PHONE_NUMBER?.VALIDATION?.TRANSLATION_LABELS
                    .CUSTOM ?? 'REGISTRATION_PHONE_NUMBER_PATTERN_VALIDATION' | translate
            }}
        </mat-error>
    </mat-form-field>
</ng-template>
